import { formatMoney } from '@nemuru-eng/js-api-client';

import { PayoutsListRowProps } from '@/components/modules/Payouts/PayoutsList/types/PayoutsListRowProps';
import { Text } from '@/components/shared/components/Text';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

export const disbursedAmountFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.5,
    field: 'disbursed_amount',
    sortable: false,
    align: 'right',
    type: 'number',
    headerName: <Text tId={'DISBURSED_AMOUNT'} />,
    renderCell: (rowData: PayoutsListRowProps) => (
      <>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'break-spaces',
            justifyContent: 'end',
            lineHeight: '1.43',
          }}
        >
          <div className={'line-clamp-3'}>{formatMoney(amountToValueMoneyMapper(rowData.row.disbursedAmount))}</div>
        </div>
      </>
    ),
  };
};
